import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ae867f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding-bottom" }
const _hoisted_2 = { class: "ion-padding-bottom" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "ion-margin-top",
  style: {"border-bottom":"1px solid var(--ion-color-medium)"}
}, null, -1))
const _hoisted_4 = { style: {"width":"fit-content"} }
const _hoisted_5 = { class: "ion-text-center" }

import {
  CustomElement,
  Language,
  Colors,
  GeneralSubElements,
  User,
  GeneralTableCardElements,
  OrderedCardsList,
  ProjectClassStudent,
  MultipleGradesParameters,
  //TmpList,
  StudentGrade,
  AlertInformation,
  /*Breakpoint,
  BreakpointVisibility,*/
  StudentProps,
} from "@/types";
import {
  executeLink,
  getAviableLanguages,
  getCurrentElement,
  getCustomMessage,
  getIcon,
  getLocale,
  checkMultiGradesParameters,
  hasGradeTypingErrors,
} from "@/utils";
import {
  IonHeader,
  IonToolbar,
  IonLabel,
  IonButton,
  IonTextarea,
  IonDatetime,
  IonDatetimeButton,
  IonModal,
  DatetimeCustomEvent,
  IonItem,
  IonCheckbox,
  IonContent,
  IonAlert,
} from "@ionic/vue";
import { nextTick, PropType, reactive, Ref, ref /*, watch*/ } from "vue";
import { useStore } from "vuex";

type AvailableModal = "warning";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleGradesManager',
  props: {
  parameters: {
    type: Object as PropType<MultipleGradesParameters>,
    required: true,
  },
  final_grades_indexes: {
    type: Object as PropType<{
      [student_id: string]: number;
    }>,
    required: true,
  },
},
  emits: ["signal_event", "close"],
  setup(__props) {

const props = __props;

const changeData = (event: DatetimeCustomEvent) => {
  const tmp_str_date = event.target.value;

  let tmp_date: Date;

  if (typeof tmp_str_date == "string") {
    tmp_date = new Date(tmp_str_date);
    if (tmp_date <= end_of_day) {
      date = tmp_date;
    } else {
      date = undefined;
    }
  } else {
    date = undefined;
  }
  date_trigger.value++;
};
const updateStudents = async () => {
  students = await executeLink(
    "/v1/project_classes/" +
      props.parameters.course_id +
      "/" +
      props.parameters.session_id +
      "/components?section=" +
      props.parameters.section +
      "&teacher_id=" +
      user.id,
    (response) => {
      const tmp_students: ProjectClassStudent[] = [];

      response.data.data.components.map((a: StudentProps) => {
        tmp_students.push(
          new ProjectClassStudent(
            a,
            "" + props.parameters.course_id,
            "" + props.parameters.session_id
          )
        );
      });

      return tmp_students;
    },
    () => []
  );

  for (const student_index in students) {
    if (!(students[student_index].id in props.final_grades_indexes)) {
      table_data.cards[""].push(
        students[student_index].toTableCard(
          user.id,
          false,
          undefined,
          undefined,
          true,
          parseInt(student_index) + 1
        )
      );
    }
  }
  trigger.value++;
};
/*const setupModalAndOpen = (window?: AvailableModal, message?: string) => {
  const actual_window: AvailableModal = window ?? store.state.event.event;
  const actual_message: string = message ?? store.state.event.data?.message;

  switch (actual_window) {
    case "warning":
      alert_information.title = getCurrentElement("warning");
      alert_information.message = actual_message;
      alert_information.buttons = [getCurrentElement("ok")];
      alert_open.value = true;
      break;
  }
};*/
const closeModal = (window: AvailableModal) => {
  switch (window) {
    case "warning":
      alert_open.value = false;
      break;
  }
};

const store = useStore();
const languages = getAviableLanguages();
const user = User.getLoggedUser() as User;
const date_trigger = ref(0);




const elements: {
  [key: string]: CustomElement;
} = {
  close: {
    id: "close",
    type: "icon",
    linkType: "event",
    content: {
      event: "close",
      icon: getIcon("close"),
    },
  },
  title: {
    id: "title",
    type: "title",
    content: getCurrentElement("grade_series_insertion"),
  },
};
const descriptions: {
  [key in keyof Language as `${Language}_description`]: string;
} = reactive({
  italian_description: "",
  english_description: "",
});
const final: Ref<boolean> = ref(false);
const colors: Colors<GeneralSubElements> = {
  text: {
    name: "primary",
    type: "var",
  },
};
const trigger = ref(0);
const table_data: OrderedCardsList<GeneralTableCardElements> = {
  order: [],
  cards: {
    "": [],
  },
};
const table_data_ref = ref(table_data);
const first_row: CustomElement[] = [
  {
    id: "index",
    type: "string",
    content: "",
  },
  {
    id: "student",
    type: "string",
    content: getCurrentElement("student"),
  },
  {
    id: "class",
    type: "string",
    content: getCurrentElement("class"),
  },
  {
    id: "learning_context",
    type: "string",
    content: getCurrentElement("learning_context"),
  },
  {
    id: "",
    type: "string",
    content: "",
  },
];
const column_sizes = ["1", "6", "2", "2", "1"];
//const disabled_grades: TmpList<string> = {};
const alert_open = ref(false);
const alert_information: AlertInformation = store.state.alert_information;
const end_of_day = new Date();
end_of_day.setHours(23, 59, 59, 999);

let date: Date | undefined = undefined,
  date_value: string | undefined,
  students: ProjectClassStudent[];
//tmp_grade: string;

updateStudents();

/*watch(final, (value) => {
  let tmp_input_grade;
  let hide_grades = false;
  let grade_input_ids: (string | number)[];

  if (value) {
    for (const student of table_data_ref.value.cards[""]) {
      if (props.final_grades_indexes[student.id] != undefined) {
        grade_input_ids =
          student.linked_elements != undefined
            ? student.linked_elements["grade"]
            : [];
        for (const grade_input_id of grade_input_ids) {
          tmp_input_grade =
            student.content[
              student.content.findIndex((a) => a.id == grade_input_id)
            ];
          disabled_grades[student.id] = tmp_input_grade.content as string;
          tmp_input_grade.content = "";
          if (tmp_input_grade.params == undefined) {
            tmp_input_grade.params = {};
          }
          tmp_input_grade.params.disabled = true;
        }
        hide_grades = true;
      }
    }
    if (hide_grades) {
      setupModalAndOpen("warning", getCurrentElement("final_grades_hide"));
    }
  } else {
    for (const id in disabled_grades) {
      for (const student of table_data_ref.value.cards[""]) {
        if (student.id == id) {
          grade_input_ids =
            student.linked_elements != undefined
              ? student.linked_elements["grade"]
              : [];
          tmp_grade = disabled_grades[id];
          for (const grade_input_id of grade_input_ids) {
            tmp_input_grade =
              student.content[
                student.content.findIndex((a) => a.id == grade_input_id)
              ];
            tmp_input_grade.content = tmp_grade;
            if (tmp_input_grade.params != undefined) {
              tmp_input_grade.params.disabled = false;
            }
          }
          delete disabled_grades[id];
          break;
        }
      }
    }
  }
});*/

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ionic_table = _resolveComponent("ionic-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), { "keep-contents-mounted": true }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_unref(IonDatetime), {
          key: trigger.value,
          id: "datetime",
          onIonChange: changeData,
          "first-day-of-week": 1,
          max: _unref(end_of_day).toISOString(),
          "hour-cycle": "h23",
          locale: _unref(getLocale)(),
          "show-clear-button": true,
          "clear-text": _unref(getCurrentElement)('clear'),
          value: _unref(date_value)
        }, null, 8, ["max", "locale", "clear-text", "value"]))
      ]),
      _: 1
    }),
    _createVNode(_unref(IonAlert), {
      "is-open": alert_open.value,
      header: _unref(alert_information).title,
      message: _unref(alert_information).message,
      buttons: _unref(alert_information).buttons,
      onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (closeModal(_unref(store).state.event.event)))
    }, null, 8, ["is-open", "header", "message", "buttons"]),
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-text-center ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.title
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.close,
                          onSignal_event: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ionic_element, {
              element: 
            _unref(getCustomMessage)(
              'description',
              _unref(getCurrentElement)('grade_insertion'),
              'title',
              colors
            )
          
            }, null, 8, ["element"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_ionic_element, {
              element: 
            _unref(getCustomMessage)(
              'description',
              _unref(getCurrentElement)('description'),
              'string',
              colors
            )
          
            }, null, 8, ["element"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
              return (_openBlock(), _createBlock(_unref(IonTextarea), {
                key: language,
                "auto-grow": true,
                modelValue: descriptions[`${language}_description`],
                "onUpdate:modelValue": ($event: any) => ((descriptions[`${language}_description`]) = $event),
                label: _unref(getCurrentElement)(language),
                "aria-label": _unref(getCurrentElement)(language),
                fill: "outline",
                class: "ion-margin-vertical"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "aria-label"]))
            }), 128))
          ]),
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(_unref(IonItem), {
              style: {"width":"fit-content"},
              lines: "none"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), {
                  "aria-label": _unref(getCurrentElement)('date'),
                  color: "primary",
                  style: {"color":"var(--ion-color-primary)"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getCurrentElement)("date")), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"]),
                (_openBlock(), _createBlock(_unref(IonDatetimeButton), {
                  key: date_trigger.value,
                  datetime: "datetime",
                  style: {"width":"fit-content"},
                  class: "ion-padding-start"
                }))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(IonLabel), {
                position: "floating",
                "aria-label": _unref(getCurrentElement)('final_grade'),
                color: "primary",
                style: {"color":"var(--ion-color-primary)"},
                class: "ion-padding-horizontal"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getCurrentElement)("final_grade")), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]),
              _createVNode(_unref(IonCheckbox), {
                modelValue: final.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((final).value = $event)),
                "aria-label": _unref(getCurrentElement)('final_grade')
              }, null, 8, ["modelValue", "aria-label"])
            ])
          ]),
          (_openBlock(), _createBlock(_component_ionic_table, {
            key: trigger.value,
            emptiness_message: 
          _unref(getCustomMessage)(
            'emptiness_message',
            _unref(getCurrentElement)('no_students')
          )
        ,
            data: table_data_ref.value,
            "onUpdate:data": _cache[3] || (_cache[3] = ($event: any) => ((table_data_ref).value = $event)),
            first_row: first_row,
            sizes: column_sizes,
            onSignal_event: _cache[4] || (_cache[4] = () => {
          const signaled_event = _unref(store).state.event;
          const student = table_data_ref.value.cards[''].find((a) => a.id == signaled_event.data.element_ref.id);
          
          let count = 0;
          let has_errors, tmp_grade, grades_input_ids;

          if (student != undefined) {
            tmp_grade = '' + student.content[signaled_event.data.element_ref.index].content
            has_errors = _unref(hasGradeTypingErrors)(signaled_event.event, tmp_grade, signaled_event.data.key_event?.key);
            if (has_errors){
              if (signaled_event.event == 'ion-input') {
                student.content[signaled_event.data.element_ref.index].content = '';
                nextTick(() => {
                  student.content[signaled_event.data.element_ref.index].content = tmp_grade.substring(0, tmp_grade.length - 1);
                });
              } else if (signaled_event.event == 'keydown' && signaled_event.data.key_event != undefined) {
                signaled_event.data.key_event.preventDefault();
              }
            } else {
              grades_input_ids = student.linked_elements != undefined ? student.linked_elements['grade'] : [];
              while (count < grades_input_ids.length) {
                if (grades_input_ids[count] == student.content[signaled_event.data.element_ref.index].id) {
                  count++;
                  continue;
                }
                student.content[student.content.findIndex((a) => a.id == grades_input_ids[count])].content = tmp_grade;
                count++;
              }
            }
          }
        })
          }, null, 8, ["emptiness_message", "data"]))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(IonButton), {
            onClick: _cache[5] || (_cache[5] = 
          () => {
            let tmp_grades = [];
            let actual_grades = undefined;
            
            table_data.cards[''].map((s) => {
              const ref_grade = s.content[s.content.findIndex(a => (s.linked_elements != undefined ? s.linked_elements['grade'] : [])[0] == a.id)].content;

              if (typeof ref_grade == 'string' && ref_grade != '') {
                tmp_grades.push({
                  student_id: parseInt(s.id),
                  grade_value: ref_grade,
                });
              }
            });
            actual_grades = _unref(checkMultiGradesParameters)(
                descriptions,
                _unref(date),
                tmp_grades
              );

            if (actual_grades != undefined && Object.values(actual_grades ?? {}).every((a) => a.grade_value != undefined)) {
              _unref(store).state.event = {
                event: 'add_grades',
                data: {
                  ...__props.parameters,
                  ...descriptions,
                  publication_date:
                    _unref(date) != undefined ? _unref(date).toISOString() : undefined,
                  grades_list: actual_grades,
                  final: final.value,
                },
                method: 'post',
              };
              _ctx.$emit('signal_event');
              _ctx.$emit('close');
            } else {
              _ctx.$emit('signal_event');
            }
          }
        )
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getCurrentElement)("insert_grade")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})